import React, { createContext, useState } from 'react'
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";
import useSWR from 'swr';
import Compressor from 'compressorjs';

const MyParticipateWaysContext = createContext();

const MyParticipateWaysProvider = ({ children }) => {
    const [error, setError] = useState({ "error": false, "message": "" });
    const [participateWay, setParticipateWay] = useState({ "participateWayTitle": "", "participateWayDescription": "" });
    const [participateWays, setParticipateWays] = useState([]);
    const [page, setPage] = useState(0);
    const [pageAdmin, setPageAdmin] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [image, setImage] = useState({});
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetcher = () => axios.get(`${API}/participateways/getallparticipateways/${page}`).then(async res => {
        setFiles(res.data.files);
        setMaxPage(res.data.maxPage);
        return res.data.response
    });

    function useParticipateWays(){
        const { data, error } = useSWR(`${API}/participateways/getallparticipateways/${page}`, fetcher);
        return {
            participateWays: data,
            isLoading: !error && !data,
            isError: error
        }
    }

    const getParticipateWaysAdmin = async () => {
        setError({ "error": false, "message": "" });
        setLoading(true);
        await axios.get(`${API}/participateways/participateways/${pageAdmin}`, config).then(res => {
            if (res.data.error) {
                if (res.data.status == "400-1") {
                    closeSession();
                }
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({ "error": true, "message": res.data.response });
                return;
            }
            setFiles(res.data.files);
            setMaxPage(res.data.maxPage);
            setParticipateWays(res.data.response);
        }).catch(err => {
            setError(defaultError);
        });
        setLoading(false);
    }

    const getFile = async (filePath) => {
        setLoading(true);
        await axios.get(`${API}/participateways/getfile/${filePath}`).then(res => {
            setError({ "error": false, "message": "" });
            if (res.data.error) {
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({ "error": true, "message": res.data.response });
                setTimeout(() => {
                    setError({ "error": false, "message": "" });
                }, 3000);
                return;
            }
            const binaryString = window.atob(res.data.response);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const url = window.URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));


            const link = document.createElement('a');
            link.href = url;
            //link.setAttribute('download', filePath);
            link.setAttribute('download', 'Documento ' + filePath.substring(filePath.length - 14));
            document.body.appendChild(link);
            link.click();
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            setError({ "error": true, "message": "Ha ocurrido un error al descargar el archivo" });
            setTimeout(() => {
                setError({ "error": false, "message": "" });
            }, 3000);
        });
    }

    const addParticipateWay = async (data) => {
        setLoading(true);
        return new Promise(async (resolve, reject) => {

            var formData = new FormData();
            formData.append("participateWayFile", data.participateWayFile.length > 0 ? data.participateWayFile[0] : new File([], "empty"));
            formData.append("participateWayTitle", data.participateWayTitle);
            formData.append("participateWayVideoPath", data.participateWayVideoPath);
            formData.append("participateWayDescription", data.participateWayDescription);
            config.headers["Content-Type"] = "multipart/form-data";
            if(data.participateWayImage.length > 0){
                new Compressor(new File([data.participateWayImage[0]], "participateWayImage.jpg", { type: "image/jpeg" }), {
                    quality: 0.5,
                    async success(result) {
                        formData.append("participateWayImage", new File([result], result.name, { type: result.type }));
                        const res = await putParticipateWay(formData, `${API}/participateways/addparticipateway`, "post");
                        resolve(res)
                    },
                    error(err){
                        setLoading(false);
                        resolve(defaultError);
                    }
                });
            }else{
                formData.append("participateWayImage", new File([], "empty"));
                const res = await putParticipateWay(formData, `${API}/participateways/addparticipateway`, "post");
                resolve(res)
            }
        });
    }

    const updateParticipateWay = (data, participateWayId) =>{
        setLoading(true);
        return new Promise(async (resolve, reject) => {

            var formData = new FormData();
            formData.append("participateWayFile", data.participateWayFile.length > 0 ? data.participateWayFile[0] : new File([], "empty"));
            formData.append("participateWayTitle", data.participateWayTitle);
            formData.append("participateWayVideoPath", data.participateWayVideoPath);
            formData.append("participateWayDescription", data.participateWayDescription);
            config.headers["Content-Type"] = "multipart/form-data";
            if(data.participateWayImage.length > 0){
                new Compressor(new File([data.participateWayImage[0]], "participateWayImage.jpg", { type: "image/jpeg" }), {
                    quality: 0.5,
                    async success(result) {
                        formData.append("participateWayImage", new File([result], result.name, { type: result.type }));
                        const res = await putParticipateWay(formData, `${API}/participateways/updateparticipateway/${participateWayId}`, "put");
                        resolve(res)
                    },
                    error(err){
                        setLoading(false);
                        resolve(defaultError);
                    }
                });
            }else{
                formData.append("participateWayImage", new File([], "empty"));
                const res = await putParticipateWay(formData, `${API}/participateways/updateparticipateway/${participateWayId}`, "put");
                resolve(res)
            }
        });
    }

    const putParticipateWay = async (formData, link, method) => {
        try{
            const res = method == "post" ? await axios.post(link, formData, config) : await axios.put(link, formData, config);
            if (res.data.status == "400-1") {
                closeSession();
            }
            if (!res.data.error) {
                getParticipateWaysAdmin();
            }
            setLoading(false);
            return res.data;
        } catch (err) {
            setLoading(false);
            return defaultError;
        }
    }

    const changeParticipateWayVisibility = async (participateWayId) => {
        try {
            const res = await axios.put(`${API}/participateways/changeparticipatewayvisibility/${participateWayId}`, {}, config)
            if (res.data.status == "400-1") {
                closeSession();
            }
            if (!res.data.error) {
                getParticipateWaysAdmin();
            }
            return res.data;
        } catch (err) {
            return defaultError;
        }
    }

    const deleteParticipateWay = async (participateWayId) => {
        setLoading(true);
        try {
            const res = await axios.delete(`${API}/participateways/deleteparticipateway/${participateWayId}`, config)
            if (res.data.status == "400-1") {
                closeSession();
            }
            if (!res.data.error) {
                getParticipateWaysAdmin();
            }
            setLoading(false);
            return res.data;
        } catch (err) {
            setLoading(false);
            return defaultError;
        }
    }

    return(
        <MyParticipateWaysContext.Provider value={{
            error,
            setError,
            participateWay,
            setParticipateWay,
            participateWays,
            setParticipateWays,
            page,
            setPage,
            pageAdmin,
            setPageAdmin,
            maxPage,
            setMaxPage,
            image,
            setImage,
            files,
            setFiles,
            loading,
            setLoading,
            useParticipateWays,
            getFile,
            getParticipateWaysAdmin,
            changeParticipateWayVisibility,
            deleteParticipateWay,
            addParticipateWay,
            updateParticipateWay
        }}>
            {children}
        </MyParticipateWaysContext.Provider>
    );
}

export { MyParticipateWaysProvider };
export default MyParticipateWaysContext;